.filters-no-results {
  text-align: center;
  margin-top: 30px;
  color: #626469;
}

@media screen and (min-width: 980px) {
  .filters-no-results {
    margin-top: 80px;
  }
}

.filters-no-results__search-icon {
  width: 50px;
  height: 50px;
  color: #cbcbcb;
  display: inline-block;
}

@media screen and (min-width: 980px) {
  .filters-no-results__search-icon {
    width: 60px;
    height: 60px;
  }
}

.filters-no-results__header {
  font-size: 18px;
  line-height: 1.3888888889;
  font-weight: bold;
  margin: 10px 0 0;
}

@media screen and (min-width: 980px) {
  .filters-no-results__header {
    font-size: 22px;
    line-height: 1.3636363636;
  }
}

.filters-no-results__message {
  font-size: 14px;
  line-height: 1.4285714286;
  margin-top: 10px;
  font-weight: 400;
}

@media screen and (min-width: 980px) {
  .filters-no-results__message {
    font-size: 16px;
    line-height: 1.5625;
    margin-top: 15px;
  }
}

.filters-no-results__clear-link {
  font-size: 14px;
  line-height: 1.4285714286;
  margin-top: 20px;
}

@media screen and (min-width: 980px) {
  .filters-no-results__clear-link {
    font-size: 16px;
    line-height: 1.5625;
    margin-top: 30px;
  }
}